import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentUrls } from '@custom/Utils/constants/apiUrls';

const generatePdfApi = createAsyncThunk(
  'generatePdfApi',
  async (appointmentId: string, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = _appointmentUrls.generatePDF;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ appointmentId }),
      });

      if (!response.ok) {
        throw new Error('Failed to generate PDF');
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to generate PDF');
    }
  }
);

export default generatePdfApi;
